import React, { useRef, useEffect, useState } from "react";
import { Link } from "react-router-dom";

import styles from "./index.module.css";

import PreviewPlayer from "../atoms/PreviewPlayer";
import useCheckPC from "../atoms/useCheckPC";

const Items = ({
  data,
  TextComponent,
  lang = "en",
  onClick,
  intersectionData,
  type,
  ...rest
}) => {
  const props = { data, lang, onClick, type, ...rest };
  const result = data || {};
  // const output = key => result[key + "_" + lang];

  const handleClick = e => {
    onClick && onClick(data);
  };

  const isPC = useCheckPC();

  const dims = type => {
    switch (type) {
      case "works":
        return {
          width: isPC ? 645 : "100%",
          height: isPC ? 400 : ""
        };
      case "teams":
        return {
          width: isPC ? 580 : "100%",
          height: isPC ? 382 : ""
        };
      default:
        return {
          width: isPC ? 500 : "100%",
          height: isPC ? 300 : ""
        };
    }
  };

  const src = type => {
    switch (type) {
      case "works":
        return {
          video: result.preview_mp4,
          image: result.preview_screenshot
        };
      case "teams":
        return {
          video: result.video_mp4,
          image: result.image_url
        };
      default:
        return {
          video: result.video_mp4,
          image: result.image_url
        };
    }
  };

  return (
    <div className={styles.itemPreviewContainer} onClick={handleClick}>
      <PreviewPlayer
        key={`${type}-preview-player`}
        className={styles.preview}
        vidSrc={src(type).video}
        imgSrc={src(type).image}
        playing={intersectionData >= 1.0}
        width={dims(type).width}
        height={dims(type).height}
      />
      {TextComponent && (
        <TextComponent
          key={`${type}-textcomponent`}
          style={{ zIndex: 100, ...props.style }}
          {...props}
        />
      )}
    </div>
  );
};

// make sure singleRefs is cleard on unmount
let singleRefs = {};
const Gallery = ({
  data,
  paths,
  containerClassName,
  lang,
  onClick,
  ...rest
}) => {
  // root of gallery
  const rootRef = useRef(); // ref to track viewport position change
  const results = data;

  // initialize on empty OR is number of results don't match
  if (!singleRefs[0] || Object.values(singleRefs).length !== results.length) {
    results.forEach((v, i) => {
      singleRefs[i] = {
        id: i,
        ref: React.createRef(), // trackers
        ratio: 0 // how visible is it?
      };
    });
  }

  const [intersectionData, setIntersectionData] = useState(singleRefs);
  const callback = entries => {
    // intersectionRatio is "how visible is this"
    // isIntersecting is "whether it is in view"
    // entry.target.id is the element property set in the component
    // that is used to reference the dict of refs
    entries.forEach(
      entry => (singleRefs[entry.target.id].ratio = entry.intersectionRatio)
    );
    setIntersectionData({ ...singleRefs });
    // console.log("within callback: ", singleRefs);
    // console.log("spreaded: ", Object.values(singleRefs).map(v => v.ratio));
  };

  // console.log(singleRefs);

  const observer = new IntersectionObserver(callback, {
    //root: rootRef.current, // position tracking reference, defaults to viewport
    // threshold: new Array(101).fill(0).map((v, i) => i * 0.01), // every 0.1% a callback is called
    threshold: 1 // when the object is visible, the callback is run
  });

  useEffect(() => {
    //const singleRefs = refs.current;
    // if (rootRef && singleRefs && singleRefs[0] && singleRefs[0].ref.current) {
    Object.values(singleRefs).forEach(
      value => value.ref.current && observer.observe(value.ref.current)
    );
    //refs.current = singleRefs;
    // }
    return () => {
      Object.values(singleRefs).forEach(value => observer.disconnect());
      //singleRefs = {};
    };
  }, [rootRef]); // do not add observer as dependency, it causes event listeners to be constantly added

  return (
    <div
      className={`${styles.galleryContainer} ${containerClassName}`}
      ref={rootRef}
    >
      {results.map((v, i) => {
        return (
          <div
            key={`${rest.type}-${i}-${JSON.stringify(v)}`}
            id={singleRefs[i] && singleRefs[i].id}
            ref={singleRefs[i] && singleRefs[i].ref}
          >
            {paths ? (
              <Link to={paths[i] || "/"}>
                <Items
                  data={v}
                  lang={lang}
                  onClick={onClick}
                  intersectionData={
                    intersectionData[i] && intersectionData[i].ratio
                  }
                  {...rest}
                />
              </Link>
            ) : (
              <Items
                data={v}
                lang={lang}
                onClick={onClick}
                intersectionData={
                  intersectionData[i] && intersectionData[i].ratio
                }
                {...rest}
              />
            )}
          </div>
        );
      })}
      <div className={styles.spacer}></div>
    </div>
  );
};

export default Gallery;
